<template>
    <tr>
        <td class="small">
            <b-form-checkbox
                    v-if="data.ignore_update === 0"
                    v-model="selected"
                    v-on:change="toggle"
            ></b-form-checkbox>
        </td>
        <td>
            {{ data.site_name}}
        </td>
        <td>
            {{ data.translated_name }}
        </td>
      <td v-if="showColumn('type')">
        {{ data.type }}
      </td>
        <td v-if="showColumn('version')" class="text-center">
            {{ data.version }}
        </td>
        <td v-if="showColumn('next_version')" class="text-center">
            {{ data.next_version }}
        </td>
        <td class="text-center">
          <span v-if="data.process_state === 8">
              <button class="btn btn--failed--link" v-on:click="localUpdateExtension()">
                  {{$t('updates.extensionupdatefaileddoitagain')}}
              </button>
          </span>

          <span v-if="data.process_state === 0 && data.ignore_update === 0">
              <button class="btn btn--success" v-on:click="localUpdateExtension()">
                  {{$t('updates.update')}}
              </button>
          </span>

          <span v-if="(data.process_state === 0 || data.process_state === 8) && errorDetails">
              <img v-b-tooltip.top="errorDetails" class="mx-2" src="/images/icon/siteinformation/icon_warning.svg"/>
          </span>

          <span v-if="data.process_state === 1">
                <font-awesome-icon :icon="['fal','spinner']" pulse></font-awesome-icon>
            </span>

          <span v-if="data.process_state === 2">
              <font-awesome-icon :icon="['fal','check-circle']" class="text--success"></font-awesome-icon>
          </span>
          <span v-if="data.process_state !== 1">
            <span v-if="data.ignore_update === 0">
              <button v-b-tooltip.top="'Ignore Extension Updates'" class="btn btn--failed--link" v-on:click="localIgnoreUpdateExtension()">
                <img src="/images/icon/siteinformation/icon_ignore.svg"/>
              </button>
            </span>
            <span v-if="data.ignore_update === 1">
              <button v-b-tooltip.top="'Not ignoring Extension Updates'" class="btn btn--failed--link" v-on:click="localIgnoreUpdateExtension()">
                <img src="/images/icon/siteinformation/icon_ignore.svg"/>
              </button>
            </span>
          </span>
        </td>
    </tr>
</template>

<script>

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {

  name: 'UpdateItem',

  props: [
    'id',
    'data',
    'details',
    'dirty',
    'inProgress',
    'sites'
  ],

  computed: {

    ...mapState(
      'updates', [
        'updatesSelected'
      ]
    ),

    ...mapGetters('local', ['getUpdatesColumns']),

    selected: {
      get () {
        return this.updatesSelected.includes(this.id)
      },
      set (value) {
        // just do nothing
      }
    },

    errorDetails () {
      if (!this.data.last_update_messages || !this.data.last_update_messages.length) {
        return false
      }

      return this.data.last_update_messages.join('; ')
    }
  },

  data () {
    return {
      updateItem: []
    }
  },

  methods: {
    ...mapMutations('updates', [
      'addSelectedUpdate',
      'removeSelectedUpdate'
    ]),

    ...mapActions('updates', [
      'updateExtension'
    ]),

    ...mapActions('site', [
      'toggleExtensionIgnoreState'
    ]),

    toggle (e) {
      if (e) {
        this.isSelected = true
        this.addSelectedUpdate(this.id)
      } else {
        this.isSelected = false
        this.removeSelectedUpdate(this.id)
      }
    },

    localUpdateExtension () {
      if (this.data.process_state === 0 || this.data.process_state === 8) {
        this.updateExtension(this.id)
        this.removeSelectedUpdate(this.id)
      }
    },
    localIgnoreUpdateExtension () {
      this.toggleExtensionIgnoreState(this.id)
    },

    showColumn (name) {
      return this.getUpdatesColumns.indexOf(name) !== -1
    }
  }

}
</script>
